"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Typography = void 0;

var _native = _interopRequireDefault(require("styled-components/native"));

var _props = require("@sloth-system/props");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

let alignmentVariant = (0, _props.variant)("alignment", {
  right: `text-align: right;`,
  center: `text-align: center;`,
  left: `text-align: left;`
});
let Typography = _native.default.Text`
  ${_props.fontFamilyProps}
  ${_props.fontSizeProps}
  ${_props.colorProps}
  ${alignmentVariant}
`;
exports.Typography = Typography;
Typography.defaultProps = {
  ff: "main",
  alignment: "right",
  fs: "m"
};